import type { Route } from '@angular/router';
import { authGuard } from '@auth';

import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('../main-view/main-view.component').then((m) => m.MainViewComponent),
  },
  {
    path: 'monthly-statement/:userOktaId',
    loadComponent: () =>
      import('../monthly-statement-view/monthly-statement-view.component').then((m) => m.MonthlyStatementViewComponent),
    // resolve: { member: memberDataResolverFn },
  },
  { path: '**', component: PageNotFoundComponent },
];
